import React from 'react';
import {connect} from 'react-redux'
import {
  GridLegacy as Grid,
} from '@mui/material';
import withErrorHandler from '../../hocs/withErrorHandler'
import axios from '../../httpClients/axios-datamerch'
import * as actions from '../../store/actions'

import { AppSettings } from '../../components';
import useClasses from '../../helpers/useClasses';

const styles = theme => ({
  root: {
    padding: "60px"
  }
});

const Settings = props => {
  const classes = useClasses(styles);
  const { onAppSettingsSave} = props
  

  const handleSubmitClick = (event, appSettings) => {
    event.preventDefault();
    
    const appSettingsData = {
      appSettings: {
        maintenance: appSettings.maintenance,
        dashboardMessageEnabled: appSettings.dashboardMessageEnabled,
        dashboardMessageSeverity: appSettings.dashboardMessageSeverity,
        dashboardMessageTitle: appSettings.dashboardMessageTitle,
        dashboardMessage: appSettings.dashboardMessage
      }
    }
    onAppSettingsSave(appSettingsData)
  };

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={4}
      >
        <Grid
          size={{xs:12, md:12}}
        >
          <AppSettings onSubmitClick={handleSubmitClick} />
        </Grid>
      </Grid>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    merchant: state.merchant.merchant,
    saving: state.merchant.saving,
    token: state.auth.token,
    dialog_id: state.merchant.dialog_id
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onAppSettingsSave: (appSettingsData) => dispatch(actions.updateAppSettings(appSettingsData))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withErrorHandler(Settings, axios))